<template>
  <p v-html="transform(this.str)" class="custom-p-label"></p>
</template>

<script>
// 占位替换
const tempReg = /\{n\d{1,}\}/g

// 图标替换
const beanImgReg = /\#bean\#/g
const coinImgReg = /\#coin\#/g
const beerImgReg = /\#beer\#/g
const chatPassImgReg = /\#chatPass\#/g
const videoPassImgReg = /\#videoPass\#/g
const callPassImgReg = /\#callPass\#/g

export default {
  props: {
    str: {
      type: String,
      default: ''
    },
    numsOption: {
      type: Array,
      default: () => {
        return [
          // {
          //   value: '',
          //   style: 'color: red'
          // }
        ]
      }
    },
    customClass: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    transform(str) {
      const packageType = this.packageName

      const nums = str.match(tempReg)
      if (nums && nums.length) {
        nums.forEach((numStrItem) => {
          const index = numStrItem.match(/\d{1,}/)[0]
          const targetObj = this.numsOption[index]
          if (targetObj) {
            str = str.replace(`{n${index}}`, `<i style="${targetObj.style || ''}" class="${targetObj.class || ''}">${targetObj.value || ''}</i>`)
          }
        })
      }

      const beans = str.match(beanImgReg)
      if (beans && beans.length) {
        str = str.replace(beanImgReg, `<span class="unique-bean-icon ${packageType}-bean ${this.customClass.bean || ''}"></span>`)
      }

      const coins = str.match(coinImgReg)
      if (coins && coins.length) {
        str = str.replace(coinImgReg, `<span class="unique-coin-icon ${packageType}-coin ${this.customClass.coin || ''}"></span>`)
      }

      const beers = str.match(beerImgReg)
      if (beers && beers.length) {
        str = str.replace(beerImgReg, `<span class="unique-beer-icon ${packageType}-beer ${this.customClass.beer || ''}"></span>`)
      }

      const chatPass = str.match(chatPassImgReg)
      if (chatPass && chatPass.length) {
        str = str.replace(chatPassImgReg, `<span class="unique-chatpass-icon ${packageType}-chatpass ${this.customClass.chatPass || ''}"></span>`)
      }

      const videoPass = str.match(videoPassImgReg)
      if (videoPass && videoPass.length) {
        str = str.replace(videoPassImgReg, `<span class="unique-videopass-icon ${packageType}-videopass ${this.customClass.videoPass || ''}"></span>`)
      }

      const callPass = str.match(callPassImgReg)
      if (callPass && callPass.length) {
        str = str.replace(callPassImgReg, `<span class="unique-callpass-icon ${packageType}-callpass ${this.customClass.callPass || ''}"></span>`)
      }

      return str
    }
  }
}
</script>
<style lang="scss">
// beer
.unique-beer-icon {
  display: inline-block;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/common/beer.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

// bean
.unique-bean-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/beans.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-bean {
  background-image: url('~@/assets/packageAssets/packages/echo/beans.png');
}

.joychat-bean {
  background-image: url('~@/assets/packageAssets/packages/joychat/beans.png');
}

.joyu-bean {
  background-image: url('~@/assets/packageAssets/packages/joyu/beans.png');
}

.kiko-bean {
  background-image: url('~@/assets/packageAssets/packages/kiko/beans.png');
}

.vava-bean {
  background-image: url('~@/assets/packageAssets/packages/vava/beans.png');
}

.vibeo-bean {
  background-image: url('~@/assets/packageAssets/packages/vibeo/beans.png');
}

.whonow-bean {
  background-image: url('~@/assets/packageAssets/packages/whonow/beans.png');
}

// coin
.unique-coin-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/coin.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-coin {
  background-image: url('~@/assets/packageAssets/packages/echo/coin.png');
}

.joychat-coin {
  background-image: url('~@/assets/packageAssets/packages/joychat/coin.png');
}

.joyu-coin {
  background-image: url('~@/assets/packageAssets/packages/joyu/coin.png');
}

.kiko-coin {
  background-image: url('~@/assets/packageAssets/packages/kiko/coin.png');
}

.vava-coin {
  background-image: url('~@/assets/packageAssets/packages/vava/coin.png');
}

.vibeo-coin {
  background-image: url('~@/assets/packageAssets/packages/vibeo/coin.png');
}

.whonow-coin {
  background-image: url('~@/assets/packageAssets/packages/whonow/coin.png');
}

// chatPass
.unique-chatpass-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/packages/vava/chat-pass.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-chatpass {
  background-image: url('~@/assets/packageAssets/packages/echo/chat-pass.png');
}

.joychat-chatpass {
  background-image: url('~@/assets/packageAssets/packages/joychat/chat-pass.png');
}

.joyu-chatpass {
  background-image: url('~@/assets/packageAssets/packages/joyu/chat-pass.png');
}

.kiko-chatpass {
  background-image: url('~@/assets/packageAssets/packages/kiko/chat-pass.png');
}

.vava-chatpass {
  background-image: url('~@/assets/packageAssets/packages/vava/chat-pass.png');
}

.vibeo-chatpass {
  background-image: url('~@/assets/packageAssets/packages/vibeo/chat-pass.png');
}

.whonow-chatpass {
  background-image: url('~@/assets/packageAssets/packages/whonow/chat-pass.png');
}

// videoPass
.unique-videopass-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/packages/vava/video-pass.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-videopass {
  background-image: url('~@/assets/packageAssets/packages/echo/video-pass.png');
}

.joychat-videopass {
  background-image: url('~@/assets/packageAssets/packages/joychat/video-pass.png');
}

.joyu-videopass {
  background-image: url('~@/assets/packageAssets/packages/joyu/video-pass.png');
}

.kiko-videopass {
  background-image: url('~@/assets/packageAssets/packages/kiko/video-pass.png');
}

.vava-videopass {
  background-image: url('~@/assets/packageAssets/packages/vava/video-pass.png');
}

.vibeo-videopass {
  background-image: url('~@/assets/packageAssets/packages/vibeo/video-pass.png');
}

.whonow-videopass {
  background-image: url('~@/assets/packageAssets/packages/whonow/video-pass.png');
}

// callPass
.unique-callpass-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;

  background-image: url('~@/assets/packageAssets/packages/vava/call-pass.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.echo-callpass {
  background-image: url('~@/assets/packageAssets/packages/echo/call-pass.png');
}

.joychat-callpass {
  background-image: url('~@/assets/packageAssets/packages/joychat/call-pass.png');
}

.joyu-callpass {
  background-image: url('~@/assets/packageAssets/packages/joyu/call-pass.png');
}

.kiko-callpass {
  background-image: url('~@/assets/packageAssets/packages/kiko/call-pass.png');
}

.vava-callpass {
  background-image: url('~@/assets/packageAssets/packages/vava/call-pass.png');
}

.vibeo-callpass {
  background-image: url('~@/assets/packageAssets/packages/vibeo/call-pass.png');
}

.whonow-callpass {
  background-image: url('~@/assets/packageAssets/packages/whonow/call-pass.png');
}
</style>
